/* Progressive enhancement only: open department deep links from native navigation. */
(() => {
  const revealDepartment = () => {
    if (!location.hash.startsWith('#department-')) return;
    const section = document.getElementById(location.hash.slice(1));
    if (section && section.matches('.swx-department-list details')) section.open = true;
  };
  window.addEventListener('hashchange', revealDepartment);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link && link.hash.startsWith('#department-') && link.origin === location.origin) {
      const section = document.getElementById(link.hash.slice(1));
      if (section && section.matches('.swx-department-list details')) section.open = true;
    }
  });
  document.addEventListener('shopify:section:load', revealDepartment);
  revealDepartment();
})();
